import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Row, Col, InputGroup, Input, Button } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { Loading } from '../../components/Loading';
import { getLocalStorage } from '../../utils';
import './Players.css';

export function Players() {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [hasSearched, setHasSearched] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const doSearch = async (term) => {
        setResults([]);
        setLoading(true);
        setHasSearched(true);
        try {
            const team = JSON.parse(getLocalStorage("team", "{}"));
            const response = await fetch(`api/player/search?name=${encodeURIComponent(term)}`,
                { headers: { "teamName": team.team } });
            const data = await response.json();
            setResults(data);
        } catch (e) {
            setResults([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const name = params.get('name');
        if (name && name.trim().length >= 2) {
            setSearchTerm(name);
            doSearch(name.trim());
        }
    }, []);

    const handleSearch = () => {
        if (searchTerm.trim().length < 2) return;
        history.replace(`/players?name=${encodeURIComponent(searchTerm.trim())}`);
        doSearch(searchTerm.trim());
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    return (
        <div className="container-players">
            <Helmet>
                <title>Jugadores</title>
            </Helmet>
            <h4>Jugadores</h4>
            <InputGroup className="search-input-group">
                <Input
                    placeholder="Buscar jugador..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <Button color="primary" onClick={handleSearch}>Buscar</Button>
            </InputGroup>

            {loading && (
                <div className="loading-wrapper">
                    <Loading />
                </div>
            )}

            {hasSearched && !loading && results.length === 0 && (
                <p className="no-results">No se encontraron jugadores.</p>
            )}

            {results.length > 0 && (
                <div className="players-table-wrapper">
                    {results.map((player, i) => (
                        <Row
                            key={player.playerId}
                            className={`player-row ${i % 2 === 0 ? 'row-even' : 'row-odd'}`}
                            onClick={() => history.push(`/player/${player.playerId}?isRFEP=false`)}
                        >
                            <Col xs="2">
                                {player.teamLogoUrl && (
                                    <img src={player.teamLogoUrl} alt="" className="team-logo-img" />
                                )}
                            </Col>
                            <Col xs="10">
                                {player.name}
                            </Col>
                        </Row>
                    ))}
                </div>
            )}
        </div>
    );
}
